export default class LegCountySelectFacts {
  constructor(countySelector) {
    this.rootElement = countySelector;
    this.allCounties = document.querySelectorAll(
      ".leg-dashboard-district__discover-facts .single-county"
    );
    this.events();
  }

  events() {
    this.rootElement.addEventListener("change", () =>
      this.selectCounty(this.rootElement)
    );
  }

  selectCounty(el) {
    const countyToShow = document.querySelector(`.js-county-${el.value}`);
    const countyToHide = document.querySelector(".--show-county");
    if (countyToHide) {
      this.hideCounty(countyToHide);
    }
    if (countyToShow) {
      countyToShow.classList.add("--show-county");
    }
  }

  hideCounty(countyToHide) {
    countyToHide.classList.remove("--show-county");
  }

  hideAllCounties() {
    if (this.allCounties.length > 0) {
      this.allCounties.forEach((county) => {
        county.classList.add("--hide-county");
      });
    }
  }
}
